import React, { Fragment, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useAlert } from 'react-alert';

// Replacing react-rangeslider (peer dep conflict with React 17) with a simple vertical slider
// import Slider from 'react-rangeslider';
import parse from "html-react-parser"

import moment from 'moment';
import Loader from '../Loader';
import { userAvatarUrl } from "../../utils/assets";

import { getResultData, reviewAndGradeResult } from './../../actions/resultActions';

import { SUBMIT_GRADE_RESULT_RESET } from './../../constants/resultConstants';

import './result.css';

	// Color mapping for slider (dynamic by range)
	const getSliderColor = (val) => {
		if (val >= 75) return '#388e3c'; // Green
		if (val >= 50) return '#7c3aed'; // Purple
		if (val > 25) return '#246ce2'; // Blue
		return '#d32f2f'; // Red for 0-25 (zero)
	};

const TheoriesGrade = ({ history, match }) => {
	const alert = useAlert();
	const dispatch = useDispatch();

	const { user, loading, error } = useSelector((state) => state.auth);
	const userId = user._id;
	const quizId = match.params.id;
	useEffect(
		() => {
			dispatch(getResultData(quizId));
		},
		[dispatch, alert]
	);

	const { rLoading, result } = useSelector((state) => state.results);
	// console.log("result ", result);
	useEffect(() => { }, [result, rLoading]);
	const [currentSubject, setCurrentSubject] = useState(0);
	const [currentQuestion, setCurrentQuestion] = useState(0);
	const [numberOfQuestions, setNumberOfQuestions] = useState(0);

	//set grade
	const [grades, setGrades] = useState([]);
	const [isDragging, setIsDragging] = useState(false);
	const barRef = useRef(null);
	
	const handleSubjectType = (e) => {
		e.preventDefault();
		const currentIndex = parseInt(e.target.dataset.id);
		setCurrentSubject(currentIndex);
		setCurrentQuestion(0);
		if (
			result !== undefined &&
			result.subjectResults !== undefined &&
			result.subjectResults.length > 0 &&
			result.subjectResults[currentIndex].results !== undefined &&
			result.subjectResults[currentIndex].results.length > 0
		) {
			setNumberOfQuestions(result.subjectResults[currentIndex].results.length);
		}
	};

	const handleQuestionTick = (e) => {
		e.preventDefault();
		const currentQue = e.target.dataset.id;
		// alert.info(currentQue);
		setCurrentQuestion(currentQue);
	};

	const handleChangeGrade = (gradeVal) => {
		if (
			result !== undefined &&
			result.subjectResults !== undefined &&
			result.subjectResults.length > 0 &&
			result.subjectResults[currentSubject].results !== undefined &&
			result.subjectResults[currentSubject].results.length > 0 &&
			result.subjectResults[currentSubject].results[currentQuestion].resultsDetail !== undefined &&
			result.subjectResults[currentSubject].results[currentQuestion].resultsDetail.theoryAnswered
		) {
			const answerId = result.subjectResults[currentSubject].results[currentQuestion].resultsDetail._id;
			const safeGrade = Math.max(0, Math.min(100, Math.round(Number(gradeVal) || 0)));
			setGrades((prev) => {
				const idx = prev.findIndex((entry) => entry.answerId === answerId);
				if (idx !== -1) {
					if (prev[idx].ansGrade === safeGrade) {
						return prev;
					}
					const updated = [...prev];
					updated[idx] = {
						answerId,
						ansGrade: safeGrade
					};
					return updated;
				}
				return [
					...prev,
					{
						answerId,
						ansGrade: safeGrade
					}
				];
			});
		}
	};

	// Map pointer position within the vertical bar back to a 0-100 grade.
	const updateGradeFromSliderPosition = (clientY) => {
		if (typeof clientY !== 'number') return;
		const barEl = barRef.current;
		if (!barEl) return;
		const rect = barEl.getBoundingClientRect();
		if (!rect.height) return;
		const offsetFromBottom = rect.bottom - clientY;
		const ratio = offsetFromBottom / rect.height;
		const nextGrade = Math.max(0, Math.min(100, Math.round(ratio * 100)));
		handleChangeGrade(nextGrade);
	};

	const handleSliderMouseDown = (event) => {
		if (event.button !== undefined && event.button !== 0) {
			return;
		}
		event.preventDefault();
		setIsDragging(true);
		updateGradeFromSliderPosition(event.clientY);
	};

	const handleSliderMouseUp = () => {
		setIsDragging(false);
	};

	const extractClientY = (touchEvent) => {
		if (touchEvent.touches && touchEvent.touches.length > 0) {
			return touchEvent.touches[0].clientY;
		}
		if (touchEvent.changedTouches && touchEvent.changedTouches.length > 0) {
			return touchEvent.changedTouches[0].clientY;
		}
		return undefined;
	};

	const handleSliderTouchStart = (event) => {
		event.preventDefault();
		const clientY = extractClientY(event);
		if (typeof clientY !== 'number') {
			return;
		}
		setIsDragging(true);
		updateGradeFromSliderPosition(clientY);
	};

	const handleSliderTouchEnd = () => {
		setIsDragging(false);
	};

	useEffect(() => {
		if (!isDragging) {
			return;
		}
		const handleMouseMove = (evt) => {
			evt.preventDefault();
			updateGradeFromSliderPosition(evt.clientY);
		};
		const handleTouchMove = (evt) => {
			const clientY = extractClientY(evt);
			if (typeof clientY !== 'number') {
				return;
			}
			evt.preventDefault();
			updateGradeFromSliderPosition(clientY);
		};
		const touchMoveOptions = { passive: false };
		window.addEventListener('mousemove', handleMouseMove);
		window.addEventListener('touchmove', handleTouchMove, touchMoveOptions);
		return () => {
			window.removeEventListener('mousemove', handleMouseMove);
			window.removeEventListener('touchmove', handleTouchMove, touchMoveOptions);
		};
	}, [isDragging]);

	useEffect(() => {
		// Ensure we stop dragging even if the pointer leaves the slider surface.
		const stopDragging = () => setIsDragging(false);
		window.addEventListener('mouseup', stopDragging);
		window.addEventListener('touchend', stopDragging);
		window.addEventListener('touchcancel', stopDragging);
		return () => {
			window.removeEventListener('mouseup', stopDragging);
			window.removeEventListener('touchend', stopDragging);
			window.removeEventListener('touchcancel', stopDragging);
		};
	}, []);

	const verticalLabels = {
		0: '0% No Attempt/Very Poor Attempt',
		25: '25% Appropriate Methodology',
		50: '50% Moderate Work Accuracy',
		75: '75% High Work Accuracy',
		100: '100% Appropriate Methodology + Excellent Work Accuracy + Correct Final Answer'
	};

	const bandColors = {
		100: '#388e3c',
		75: '#1976d2',
		50: '#fdd835',
		25: '#fbc02d',
		0: '#d32f2f'
	};

	const verticalLabelEntries = [
		{ value: 100, label: verticalLabels[100] },
		{ value: 75, label: verticalLabels[75] },
		{ value: 50, label: verticalLabels[50] },
		{ value: 25, label: verticalLabels[25] },
		{ value: 0, label: verticalLabels[0] }
	];

	const resolveBand = (val) => {
		if (val >= 90) return { value: 100, label: verticalLabels[100], color: bandColors[100] };
		if (val >= 75) return { value: 75, label: verticalLabels[75], color: bandColors[75] };
		if (val >= 50) return { value: 50, label: verticalLabels[50], color: bandColors[50] };
		if (val >= 25) return { value: 25, label: verticalLabels[25], color: bandColors[25] };
		return { value: 0, label: verticalLabels[0], color: bandColors[0] };
	};

	const splitLabel = (label) => {
		const match = typeof label === 'string' ? label.match(/^(\d+%)\s*(.*)$/) : null;
		return match ? { percent: match[1], text: match[2] } : { percent: '', text: label };
	};

	const formatPc = (p) => p + '%';

	const handleSubmitGrade = (e) => {
		e.preventDefault();
		// console.log('grades', grades);
		if (grades.length > 0) {
			dispatch(reviewAndGradeResult(userId, quizId, grades));
		} else {
			alert.error('Please review and grade all questions to submit.');
			return false;
		}
	};

	const { isGraded, gradeResult } = useSelector((state) => state.results);

	useEffect(
		() => {
			if (isGraded === true && isGraded != undefined) {
				alert.success('Result graded successfully.');
				history.push(`/theories-results/${quizId}`);
				dispatch({
					type: SUBMIT_GRADE_RESULT_RESET
				});
			}
		},
		[dispatch, isGraded, alert, gradeResult]
	);

	return (
		<Fragment>
			{rLoading ? (
				<Loader />
			) : (
				<Fragment>
					<section className="auth-dash-sec fullHt" style={{ padding: '0px' }}>
						<div className="left-navigations">
							<div className="user-exam">
								<div className="user-pros-exam">
									<img src={userAvatarUrl()} alt="user" />
								</div>
								<h4>
									<b>Name</b>: {user.first_name} {user.last_name}
								</h4>
								<h4>
									<i className="fas fa-calculator" /> : Study
								</h4>
							</div>
							<div className="bot-examers">
								<h2>Subjects</h2>
								<div className="subject-tab">
									<ul className="nav nav-tabs" role="tablist">
										{result !== undefined &&
											result.subjectResults !== undefined &&
											result.subjectResults.length > 0 &&
											result.subjectResults.map((subItem, i) => {
												return (
													<Fragment key={i}>
														<li role="presentation" className={currentSubject === i ? "active" : ""}>
															<a
																href="#"
																data-id={i}
																onClick={handleSubjectType}
															>
																{subItem.subject.title}
															</a>
														</li>
													</Fragment>
												);
											})}
									</ul>
								</div>
							</div>
						</div>
						<div className="right-auth-landing edit-pros">
							<div className="main-view-content">
								<div className="all-ourt-style w-80-cust clearfix">
									<div className="sel-exam-quest">
										<h4 style={{ fontSize: 17 }}>Questions</h4>
										<div className="quet-lister" style={{ marginTop: 0 }}>
											{result !== undefined &&
												result.subjectResults !== undefined &&
												result.subjectResults.length > 0 &&
												result.subjectResults[currentSubject].results !== undefined &&
												result.subjectResults[currentSubject].results.length > 0 &&
												[
													...Array(result.subjectResults[currentSubject].results.length)
												].map((e, i) => {
													let className = '';
													if (currentQuestion === i) {
														className = 'isActiveQuestion active';
													}
													return (
														<Fragment key={i}>
															<a
																style={{
																	width: '32px',
																	height: '32px',
																	lineHeight: '27px'
																}}
																className={className}
																href="#"
																data-id={i}
																onClick={handleQuestionTick}
															>
																{i + 1}
															</a>{' '}
														</Fragment>
													);
												})}
										</div>
									</div>
								</div>
								{result !== undefined &&
									result.subjectResults !== undefined &&
									result.subjectResults.length > 0 &&
									result.subjectResults[currentSubject].results !== undefined &&
									result.subjectResults[currentSubject].results.length > 0 && (
										<Fragment>
											<div className="all-ourt-style w-80-cust work-info exam-set">
												<div className="all-heads clearfix">
													<h2>{parseInt(currentQuestion) + 1}{". "}
													{parse(
														result.subjectResults[currentSubject].results[currentQuestion]
															.theory.title
													)}
													{parse(
														result.subjectResults[currentSubject].results[currentQuestion]
															.theory.question
													)}
													</h2>
												</div>
												<div className="lister-opt-ans">
													<div className="row">
														<div className="col-sm-12">
															<h3 style={{ fontSize: 15 }}>
																<span style={{ fontSize: 16 }}>Answered</span>:
																{parse(result !== undefined &&
																	result.subjectResults !== undefined &&
																	result.subjectResults.length > 0 &&
																	result.subjectResults[currentSubject].results !==
																	undefined &&
																	result.subjectResults[currentSubject].results.length >
																	0 &&
																	result.subjectResults[currentSubject].results[
																		currentQuestion
																	].resultsDetail !== undefined &&
																	result.subjectResults[currentSubject].results[
																		currentQuestion
																	].resultsDetail.theoryAnswered)}
															</h3>
														</div>
														<div className="col-sm-12">
															<h3 style={{ fontSize: 15 }}>
																<span style={{ fontSize: 16 }}>Correct Answer</span>:
																{parse(result !== undefined &&
																	result.subjectResults !== undefined &&
																	result.subjectResults.length > 0 &&
																	result.subjectResults[currentSubject].results !==
																	undefined &&
																	result.subjectResults[currentSubject].results.length >
																	0 &&
																	result.subjectResults[currentSubject].results[
																		currentQuestion
																	].resultsDetail !== undefined &&
																	result.subjectResults[currentSubject].results[
																		currentQuestion
																	].resultsDetail.theoryCorrectAnswer)}
															</h3>
														</div>

														<div className="col-sm-12">
															<h3 style={{ fontSize: 15 }}>
																<span style={{ fontSize: 16 }}>Detailed Answer</span>:
																{parse(result !== undefined &&
																	result.subjectResults !== undefined &&
																	result.subjectResults.length > 0 &&
																	result.subjectResults[currentSubject].results !==
																	undefined &&
																	result.subjectResults[currentSubject].results.length >
																	0 &&
																	result.subjectResults[currentSubject].results[
																		currentQuestion
																	].theory !== undefined &&
																	result.subjectResults[currentSubject].results[
																		currentQuestion
																	].theory.detailedAnswer)}
															</h3>
														</div>
													</div>
												</div>
											</div>

											<div className="all-ourt-style w-80-cust clearfix">
												<div className="sel-exam-quest">
													<h4 style={{ fontSize: 17 }}>Mark and Grade Yourself</h4>
													<div className="mark-of-grade">
														{(() => {
															const subjectResults = result.subjectResults[currentSubject];
															const currentResultItem = subjectResults?.results?.[currentQuestion];
															const resultDetail = currentResultItem?.resultsDetail;
															const answerId = resultDetail?._id;
															const storedGrade = grades.find((g) => g.answerId === answerId)?.ansGrade;
															const persistedGrade = resultDetail?.resultGrade !== undefined
																? resultDetail.resultGrade
																: (resultDetail?.ansGrade !== undefined ? resultDetail.ansGrade : 0);
															const gradeValRaw = storedGrade !== undefined ? storedGrade : persistedGrade;
															const gradeValNumber = Number(gradeValRaw);
															const normalizedGrade = Math.max(0, Math.min(100, Number.isNaN(gradeValNumber) ? 0 : Math.round(gradeValNumber)));
															const activeBand = resolveBand(normalizedGrade);
															const pointerColor = activeBand.color || getSliderColor(normalizedGrade);
															const pointerPosition = Math.max(0, Math.min(100, normalizedGrade));
															return (
																<div className="grade-scale-layout">
																	<div className="grade-scale-track-wrapper">
																		<div
																			className="grade-scale-bar"
																			ref={barRef}
																			onMouseDown={handleSliderMouseDown}
																			onMouseUp={handleSliderMouseUp}
																			onTouchStart={handleSliderTouchStart}
																			onTouchEnd={handleSliderTouchEnd}
																			style={{ cursor: isDragging ? 'grabbing' : 'pointer' }}
																		>
																			<div className="grade-scale-track" />
																			{verticalLabelEntries.map((entry) => (
																				<div
																					key={`tick-${entry.value}`}
																					className="grade-scale-tick"
																					style={{ top: `${100 - entry.value}%` }}
																				/>
																			))}
																			<div
																				className="grade-scale-pointer"
																				style={{ top: `${100 - pointerPosition}%`, '--pointer-color': pointerColor }}
																			>
																				<span className="grade-scale-pointer-knob" />
																				<span className="grade-scale-pointer-value">{formatPc(normalizedGrade)}</span>
																			</div>
																			<input
																				className="grade-scale-slider"
																				type="range"
																				min={0}
																				max={100}
																				step={1}
																				value={normalizedGrade}
																				onChange={(e) => handleChangeGrade(Number(e.target.value))}
																			/>
																		</div>
																		<div className="grade-scale-labels">
																			{verticalLabelEntries.map((entry) => {
																				const parts = splitLabel(entry.label);
																				const isActive = entry.value === activeBand.value;
																				return (
																					<div
																						key={entry.value}
																						className="grade-scale-label"
																						data-active={isActive ? 'true' : undefined}
																						style={{ top: `${100 - entry.value}%` }}
																					>
																						<span className="grade-scale-label-line" style={{ background: bandColors[entry.value] || '#1f2937' }} />
																						<div className="grade-scale-label-content">
																							<span
																								className="grade-scale-label-value"
																								style={{ color: bandColors[entry.value] || '#1f2937' }}
																							>
																								{parts.percent || `${entry.value}%`}
																							</span>
																							<span className="grade-scale-label-text">{parts.text}</span>
																						</div>
																					</div>
																				);
																			})}
																		</div>
																	</div>
																	<div className="grade-scale-description" style={{ '--pointer-color': pointerColor }}>
																		{activeBand.label}
																	</div>
																</div>
															);
														})()}
													</div>
												</div>
											</div>
										</Fragment>
									)}

								<div className="all-ourt-style w-80-cust next-prev-cust clearfix">
									<div className="pull-left">
										<button
											type="submit"
											className="btn review-grade-btn"
											// disabled={true}
											onClick={handleSubmitGrade}
										>
											Submit Test
										</button>
									</div>
								</div>
							</div>
						</div>
					</section>
				</Fragment>
			)}
		</Fragment>
	);
};

export default TheoriesGrade;
